module.exports = __webpack_public_path__ + "static/media/s4.c05c562a.png";